let refreshModalCallback: ((show: boolean) => void) | null = null;
let isInterceptorInitialized = false;
let isModalShown = false;

export function setRefreshModalCallback(callback: (show: boolean) => void) {
  refreshModalCallback = callback;
  if (!isInterceptorInitialized && typeof window !== "undefined") {
    initializeInterceptor();
  }
}

export function showRefreshModal() {
  if (refreshModalCallback && !isModalShown) {
    isModalShown = true;
    refreshModalCallback(true);
  }
}

export function hideRefreshModal() {
  if (refreshModalCallback) {
    isModalShown = false;
    refreshModalCallback(false);
  }
}

function checkIfRequiresRefresh(data: any): boolean {
  if (!data) return false;

  if (
    data.error === "session_expired" ||
    data.error === "SESSION_EXPIRED" ||
    data.requiresRefresh === true ||
    data.error === "SESSION_REFRESH_REQUIRED"
  ) {
    return true;
  }

  if (data.code === 401 || data.code === 403 || data.code === 414) {
    return true;
  }

  if (data.code && String(data.code).startsWith("4")) {
    const errorMessage = (data.message || data.error || "").toLowerCase();
    if (
      errorMessage.includes("session") ||
      errorMessage.includes("sessione") ||
      errorMessage.includes("expired") ||
      errorMessage.includes("scaduta")
    ) {
      return true;
    }
  }

  return false;
}

function initializeInterceptor() {
  if (isInterceptorInitialized || typeof window === "undefined") {
    return;
  }

  const originalFetch = window.fetch;

  window.fetch = async function (
    input: RequestInfo | URL,
    init?: RequestInit
  ): Promise<Response> {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input instanceof Request
            ? input.url
            : "";

    if (url.includes("/api/booking/")) {
      const response = await originalFetch(input, init);

      if (!isModalShown) {
        try {
          const clonedResponse = response.clone();
          const contentType = clonedResponse.headers.get("content-type");

          if (contentType && contentType.includes("application/json")) {
            const data = await clonedResponse.json();

            if (checkIfRequiresRefresh(data)) {
              showRefreshModal();
            }
          }
        } catch (e) {
        }
      }

      return response;
    }

    return originalFetch(input, init);
  };

  isInterceptorInitialized = true;
}
